import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { calculateTotal } from "../../Utility/utility.js"
import { resetAccount } from "../../state/ledgerSlice.jsx"
import { LoadingCard, MainContainer, NextUITable } from "../../components/index.js"
import ErrorCard from "../../components/ErrorCard.jsx"
import { FOOTER_TYPE } from "../../components/NextUITable.jsx"
import { resetFilter } from "../../state/grayStockSlice.jsx"

const GrayStockDetail = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { compCode } = useSelector((state) => state.company)

  const { currentGrayStock, filter } = useSelector((state) => state.grayStock)
  //let [data, setData] = useState([])
  const {
    isPending,
    isError,
    data=[],
  //  data: grayData = [],
    mutate: grayStockFilter
  } = usePost({
    url: apiRoute.grayStock.fetch,
    queryKey: "GrayStockDetail",

  })
  // useEffect(() => {
  //   setData(grayData)
  // }, [grayData])

const funLoadData=()=>{
  grayStockFilter({
    data: {
      compcode: compCode.join(","),
      fromdate: filter.fromdate
        ? new Date(filter.fromdate).toISOString().split("T")[0]
        : null,
      todate: filter.todate ? new Date(filter.todate).toISOString().split("T")[0] : null,
      item_code:
        currentGrayStock.item_code !== "" ? currentGrayStock.item_code : null,
      mitem_code: filter.mitemCode ? filter.mitemCode : null,
      unit_id:filter?.unitId ||'',
      chal_no:null,
      action: "DETAIL",
    }
  })
//setData(grayData)
}
  useEffect(() => {
   funLoadData();
    //setData(grayData)
  }, [])

  

  // let totalTakaNo = useMemo(
  //   () =>
  //     calculateTotal({
  //       data: data,
  //       columnName: "Taka_No",
  //     }),
  //   [data]
  // )
  const totalTaka = useMemo(() => {
    return data.length
  }, [data])
  let totalMeter = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Meter",
      }),
    [data]
  )

  let downloadDataFooter = {
    item_code: "",
    item_desc: "",
    Taka_No: "Total: " + data.length,
    Meter: "Total: " + totalMeter,
  }

  const exportColumns = [
    {
      uid: "item_code",
      name: "Item Code",
    },
    {
      uid: "item_desc",
      name: "Item Desc",
    },
    {
      uid: "Taka_No",
      name: "Taka No",
    },
    {
      uid: "Meter",
      name: "Meter",
    },
  ]

  const handleClickPrev = () => {
    navigate(linksUrl.grayStock.get)
    //dispatch(resetFilter())
  }

  const INITIAL_VISIBLE_COLUMNS = ["item_code", "item_desc", "Taka_No", "Meter"]

  const columns = [
    {
      uid: "item_code",
      name: "Item Code",
      sortable: true,
    },
    {
      uid: "item_desc",
      name: "Item Desc",
      sortable: true,
    },
    {
      uid: "Taka_No",
      name: "Taka No",
      sortable: true,

      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTaka,
      },
    },
    {
      uid: "Meter",
      name: "Meter",
      sortable: true,

      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalMeter,
      },
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName="Gray Stock Detail"
        info={[
          ["Item Code", currentGrayStock.item_code],
          // [
          //   "Date",
          //   format(new Date(filter.fromdate), "dd/MM/yyyy"),
          //   "to",
          //   format(new Date(filter.todate), "dd/MM/yyyy"),
          // ],
        ]}
        breadcrumbs={["Gray Stock", "Gray Stock Detail"]}
        prevPage={{
          show: true,
          onClick: handleClickPrev,
        }}
      >
        {/* end of filter */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Gray_Stock_detail"
          showAdvanceFilter={false}
          id="item_code"
        />
      </MainContainer>
    </div>
  )
}

export default GrayStockDetail
